import styled from '@emotion/styled';

const Thead = styled.thead`
  background-color: #ffffff;
`;

export default Thead;
